import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { UniversalSelect } from '@feathr/components';

interface ISelectOption {
  id: string;
  name: string;
}

interface IProps {
  onSelectOptionalFields: (values: ISelectOption[]) => void;
  selectedOptionalFields: ISelectOption[];
}

function DataFieldsSelect({
  onSelectOptionalFields,
  selectedOptionalFields,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const optionalFieldOptions: ISelectOption[] = [
    { id: 'address', name: t('Address') },
    // TODO: Add these fields once backend supports them
    // { id: 'honoree', name: t('Honoree') },
    // { id: 'note', name: t('Note') },
    // { id: 'company_match', name: t('Company Match') },
  ];

  return (
    <UniversalSelect<ISelectOption>
      helpText={t('Automatically includes essential data')}
      isLoading={false}
      isMulti={true}
      label={t('Data fields')}
      name={'optional_fields'}
      onSelectMulti={onSelectOptionalFields}
      optional={true}
      options={optionalFieldOptions}
      placeholder={t('Select additional data')}
      value={selectedOptionalFields}
    />
  );
}

export default DataFieldsSelect;
